/* System-wide date display format: dd/mm/yyyy */
export const fmtDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = String(iso).slice(0, 10).split("-");
  return y && m && d ? `${d}/${m}/${y}` : String(iso).slice(0, 10);
};

export const fmtDateTime = (iso) => {
  if (!iso) return "";
  const t = String(iso).slice(11, 16);
  return fmtDate(iso) + (t ? ` ${t}` : "");
};
